import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class FinePrintPopup extends UcoastEl {
    static htmlSelector = 'fine-print-popup'
    closeButtons: NodeListOf<HTMLButtonElement>
    overlay: HTMLElement
    agree: boolean

    constructor() {
        super()
        this.closeButtons = q.rl('.fine-print-popup__close', this)
        this.overlay = q.rs('.fine-print-popup__overlay', this)
        this.agree = this.dataset.agree == 'true'

        for (const button of this.closeButtons) {
            button.addEventListener('click', this.closePopup.bind(this))
        }

        this.classList.remove('loading')
        this.classList.add('active')
        document.body.classList.add('overflow-hidden')

        if(!this.agree) this.overlay.addEventListener('click', this.closePopup.bind(this))
        document.addEventListener('keyup', this.onKeyUp.bind(this))
    }

    closePopup(e: Event) {
        e.preventDefault()
        const target = e.currentTarget as HTMLElement
        if(!target) return
        this.classList.remove('active')
        document.body.classList.remove('overflow-hidden')
    }

    onKeyUp(e: KeyboardEvent) {
        if(e.key === "Escape") this.closePopup(e)
    }
}
